import React, { FC } from 'react';
import {
  MOBILE_PRIMARY_CTA_CLASS,
  MOBILE_PRIMARY_CTA_DISABLED_CLASS,
  MOBILE_PRIMARY_CTA_ENABLED_CLASS,
} from './primary-cta';

interface NavRowProps {
  onBack: () => void;
  onNext: () => void;
  nextLabel?: string;
  backLabel?: string;
  nextDisabled?: boolean;
  loading?: boolean;
  sticky?: boolean;
  footerSlot?: React.ReactNode;
  hint?: React.ReactNode;
}

const NavRow: FC<NavRowProps> = ({
  onBack,
  onNext,
  nextLabel = 'Continue',
  backLabel = 'Back',
  nextDisabled = false,
  loading = false,
  sticky = true,
  footerSlot,
  hint,
}) => {
  const disabled = nextDisabled || loading;

  const mobileNextButton = (
    <button
      type="button"
      onClick={onNext}
      disabled={disabled}
      className={`${MOBILE_PRIMARY_CTA_CLASS} ${
        disabled ? MOBILE_PRIMARY_CTA_DISABLED_CLASS : MOBILE_PRIMARY_CTA_ENABLED_CLASS
      }`}
    >
      {loading && (
        <span
          className="inline-block w-4 h-4 rounded-full border-2 border-white border-t-transparent animate-spin"
        />
      )}
      {loading ? 'Submitting...' : nextLabel}
    </button>
  );

  if (!sticky) {
    return (
      <div className="flex justify-between mt-8 pt-5 border-t border-slate-100">
        <button
          type="button"
          onClick={onBack}
          disabled={loading}
          className={`px-5 py-2.5 rounded-xl text-sm font-semibold border-2 border-slate-200 text-slate-600 hover:bg-slate-50 transition-all ${
            loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
          }`}
        >
          {backLabel}
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={disabled}
          className={`px-6 py-2.5 rounded-xl text-sm font-bold text-white transition-all inline-flex items-center gap-2 min-w-btn justify-center ${
            disabled ? 'bg-slate-300 cursor-not-allowed' : 'bg-brand cursor-pointer'
          }`}
        >
          {loading && (
            <span
              className="inline-block w-4 h-4 rounded-full border-2 border-white border-t-transparent animate-spin"
            />
          )}
          {loading ? 'Submitting...' : nextLabel}
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Desktop: inline nav row */}
      <div className="hidden md:flex justify-between mt-8 pt-5 border-t border-slate-100">
        <button
          type="button"
          onClick={onBack}
          disabled={loading}
          className={`px-5 py-2.5 rounded-xl text-sm font-semibold border-2 border-slate-200 text-slate-600 hover:bg-slate-50 transition-all ${
            loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
          }`}
        >
          {backLabel}
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={disabled}
          className={`px-6 py-2.5 rounded-xl text-sm font-bold text-white transition-all inline-flex items-center gap-2 min-w-btn justify-center ${
            disabled ? 'bg-slate-300 cursor-not-allowed' : 'bg-brand cursor-pointer'
          }`}
        >
          {loading && (
            <span
              className="inline-block w-4 h-4 rounded-full border-2 border-white border-t-transparent animate-spin"
            />
          )}
          {loading ? 'Submitting...' : nextLabel}
        </button>
      </div>

      {/* Mobile: sticky footer */}
      <div className="portal-navrow-spacer md:hidden" aria-hidden />
      <div className="portal-navrow--sticky md:hidden">
        {footerSlot}
        {mobileNextButton}
        {hint && (
          <p className="text-xs text-slate-500 text-center mt-2 leading-snug">{hint}</p>
        )}
      </div>
    </>
  );
};

export default NavRow;
